import { FC } from "react";
import React, { useEffect, useRef } from "react";
import { useAppDispatch } from "src/hooks";
import { useAppSelector } from '../../hooks';
import { useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import "src/styles/profile.css";
import { useState, useContext } from "react";
import Asynchronous from '../../components/jsx_components/Autocomplete';
import Asynchronous2 from '../../components/jsx_components/AutocompleteV2';

import { clientsData3 } from './../../features/clients/WagonClientsActions';
import { contactsData3 } from './../../features/contacts/WagonContactsActions';

import { clientsData, dataUpload } from './../../features/clients/clientsActions';
import { contactsData } from './../../features/contacts/contactsActions';
import { wagonTypesData } from './../../features/wagontype/wagonTypeActions';
import { requestTypesData } from './../../features/requesttype/requestTypeActions';

import ButtonGroup from '@mui/material/ButtonGroup';
import InputPhoneField from '../../components/jsx_components/InputPhoneField';
import { Box } from "@mui/system";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { PhoneArr, EmailArr, Client, Contact, ClientWithID, ContactWithID, ContactWithOutID } from '../../types/request.type';
import { InsertRepair } from '../../types/request.type';

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { ruRU } from '@mui/x-date-pickers/locales';
import { ruRU as dataGridruRU } from '@mui/x-data-grid';
import { ruRU as coreruRU } from '@mui/material/locale';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { createTheme } from '@mui/material/styles';

import { repairsData, repairsDataID, repairsDataPost, repairsDataUpdate } from "src/features/repairs/repairsActions";


import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { contactsDataPost, contactsDataUpdate } from './../../features/contacts/contactsActions';
import {
  setWagonNumber, setStaffWagonNumber, setRoute, setStation, setProblems, setResultProblems, setDescription, setExecutor, setDone, setWagonType, setWagonTypeId, setExternalNum, setRouteNumber, setRequestTypeId, setRequestType, setNum, setWagonBuildDate, setTimeArrival, setCompleteDate, setTimeDeparture,
  setClientContacts0, setWagonContacts0, setReset
} from "src/features/repairs/createNewRepairSlice";
import uuid from "react-uuid";
import { CircularProgress, IconButton, TextField } from "@mui/material";
import { green } from "@mui/material/colors";
import FileUpload from "react-mui-fileuploader";
import { ExtendedFileProps } from "react-mui-fileuploader/dist/types/index.types";

export type TypeSnack = {
  children: string;
  title: string;
} | null;


const theme = createTheme(
  {
    palette: {
      primary: { main: '#1976d2' },
    },
  },
  ruRU,
  dataGridruRU,
  coreruRU, // core translations
);


export const CreateRepairRequestPage: FC = () => {

  const [snackbar, setSnackbar] = React.useState<TypeSnack>(null);
  const handleCloseSnackbar = () => { setSnackbar(null); navigate('/requests'); };
  const handleCloseSnackbar0 = () => { setSnackbar(null); };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const repairRequest = useAppSelector(state => state.repair_request.repair_request);

  const repairRequestID = useAppSelector(state => state.repair_requestID.repairRequest);

  const [loading, setLoading] = React.useState(true);

  const [selectedRows, setSelectedRows] = React.useState<number[]>([]);

  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      console.log('page loaded');
      
      setTimeout(() => {
        setLoading(false);
      }, 1500);

      // do something else
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => {window.removeEventListener('load', onPageLoad);}
    }
  }, []);




  const idRequest = params.idRequest;

  const [client_contacts_ids, setClientContactsIds] = useState<number[]>([]);
  const [wagon_contacts_ids, setWagonContactsIds] = useState<number[]>([]);

  const [clientEmpty, setClientEmpty] = useState<ClientWithID>({ id: 777777, title: "FAKE" });

  //Need refresh
  const [needRefresh, setNeedRefresh] = useState<boolean>(false);

  const [asynchronous2, setAsynchronous2] = useState<number[]>([1]);

  // Клиенты
  const [clients1, setClients1] = useState<Client>("");
  const [clients1_id, setClients1_id] = useState<ClientWithID>();

  //Контакты
  const [contacts2, setContacts2] = useState<Contact>("");
  const [contacts2_id, setContacts2_id] = useState<ContactWithID>(null);


  //Клиенты и контакты 1
  const childToParent1_clients = (childdata1: Client) => {
    setClients1(childdata1);
    setContacts2("");
  };

  const childToParent1_id_clients = (childdata1: ClientWithID) => {
    setClients1_id(childdata1);
    setContacts2_id(null);
  };


  //Клиенты и контакты 1
  const childToParent2_clients = (childdata3: Client) => {
    setClients3(childdata3);
    setContacts3("");
  };

  const childToParent2_id_clients = (childdata3: ClientWithID) => {
    setClients3_id(childdata3);
    setContacts3_id(null);
  };



  // Клиенты
  const [clients3, setClients3] = useState<Client>("");
  const [clients3_id, setClients3_id] = useState<ClientWithID>();

  //Контакты
  const [contacts3, setContacts3] = useState<Contact>("");
  const [contacts3_id, setContacts3_id] = useState<ContactWithID>(null);

  //Клиенты и контакты 2
  const childToParent3_clients = (childdata3: Client) => {
    setClients3(childdata3);
    setContacts3("");
  };

  const childToParent3_id_clients = (childdata3: ClientWithID) => {
    setClients3_id(childdata3);
    setContacts3_id(null);
  };

  /////////////////////////////////////////////////////////////////////////////////////


  //Контакты 1
  const childToParent3_contact3 = (contact: ContactWithID[]) => {

  };

  const childToParent3_id_contact3 = (contact: ContactWithID) => {
    if (contact?.id!) {
      setClientContactsIds([...client_contacts_ids, contact?.id!]);
      dispatch(setClientContacts0([...repairRequest.client_contacts, contact]))
    };
  };

  const childToParent3_id_contact3_clear = (contact: ContactWithID) => {


    var array = [...client_contacts_ids]; // make a separate copy of the array

    var results = [];
    for (let i = 0; i < array.length; i++) {
      if (array[i] === contact?.id!) {
        results.push(i);
      }
    }



    var array2 = client_contacts_ids.filter(item => item !== contact?.id!);
    if (results.length > 1) array2.push(contact?.id!);
    setClientContactsIds(array2);
    if (results.length <= 1) dispatch(setClientContacts0(repairRequest.client_contacts.filter(item => item?.id !== contact?.id!)));

  };



  //Контакты 2 (на вагоне)
  const childToParent3_contact3_2 = (contact: ContactWithID) => {

  };

  const childToParent3_id_contact3_2 = (contact: ContactWithID) => {

    if (contact?.id!) {
      setWagonContactsIds([...wagon_contacts_ids, contact?.id!]);
      dispatch(setWagonContacts0([...repairRequest.wagon_contacts, contact]));
    }

  };

  const childToParent3_id_contact3_2_clear = (contact: ContactWithID) => {

    setWagonContactsIds(wagon_contacts_ids.filter(item => item !== contact?.id!));
    dispatch(setWagonContacts0(repairRequest.wagon_contacts.filter(item => item?.id !== contact?.id!)));

  };


  ////////////////////////////////////////////////////////////////////////////////////

  // Parent To Child
  const handleParentToChild = () => {

  };

  //То что в компоненты идет

  const { dataClients } = useAppSelector((state) => state.clients);
  const { dataContacts } = useAppSelector((state) => state.contacts);
  const { dataWagonTypes } = useAppSelector((state) => state.wagontypes);
  const { dataRequestTypes } = useAppSelector((state) => state.requesttypes);
  const { dataContacts3 } = useAppSelector((state) => state.contacts3);


  //Клиенты
  useEffect(() => {
    dispatch(clientsData()); // то что в экшине
  }, [dispatch]);

  useEffect(() => {
    dispatch(clientsData3()); // то что в экшине
  }, [dispatch]);

  //Типы вагонов
  useEffect(() => {
    dispatch(wagonTypesData()); // то что в экшине
  }, [dispatch]);

  //Типы запросов
  useEffect(() => {
    dispatch(requestTypesData()); // то что в экшине
  }, [dispatch]);


  //Контакты
  useEffect(() => {
    if (clients1_id?.id) {
      dispatch(contactsData(clients1_id)); // то что в экшине
    } else {
      if (!clients1_id) {

        dispatch(contactsData(clientEmpty)); // то что в экшине

      }
    }
  }, [clients1_id, dispatch]);



  //Контакты
  useEffect(() => {
    dispatch(contactsData3()); // то что в экшине

  }, [dispatch]);


  const sendValueInsert = (repair: InsertRepair) => {

    dispatch(repairsDataPost(repair)).then(() => {
      if (clients1_id !== undefined) dispatch(repairsData());
    })
  }

  const sendValueUpdate = (repair: InsertRepair) => {

    dispatch(repairsDataUpdate(repair)).then(() => {
      if (clients1_id !== undefined) dispatch(repairsData());
    })
  }


  //Редактура запроса
  useEffect(() => {


    if (idRequest !== undefined && Number(idRequest) > 0) {

      setAsynchronous2([1]);
      let n = 1;

      while (n < repairRequestID.client_contacts.length) {

        const newA = Date.now();
        setAsynchronous2(v => [...v, newA])
        n++;

      }

      n = 1;
      setAsynchronous2_2([1]);
      while (n < repairRequestID.wagon_contacts.length) {
        const newA = Date.now();
        setAsynchronous2_2(v => [...v, newA])
        n++;
      }

      dispatch(repairsDataID(Number(idRequest))).then(() => {

        setClients1_id({ id: repairRequestID.client.id, title: repairRequestID.client.title });

        //client_contacts
        dispatch(setClientContacts0(repairRequestID.client_contacts));
        dispatch(setWagonContacts0(repairRequestID.wagon_contacts));
        dispatch(setNum(repairRequestID.num));
        dispatch(setExternalNum(repairRequestID.external_num));
        dispatch(setWagonNumber(repairRequestID.wagon_number));
        dispatch(setStaffWagonNumber(repairRequestID.staff_wagon_number));
        dispatch(setRoute(repairRequestID.route));
        dispatch(setStation(repairRequestID.appearance.station));
        dispatch(setProblems(repairRequestID.problems));
        dispatch(setResultProblems(repairRequestID.result.problems));
        dispatch(setDescription(repairRequestID.result.description));
        dispatch(setExecutor(repairRequestID.executor));
        dispatch(setDone(repairRequestID.result.done));
        dispatch(setWagonType(repairRequestID.wagon_type.title));
        dispatch(setWagonTypeId(repairRequestID.wagon_type.type));
        dispatch(setRouteNumber(repairRequestID.route_number));
        dispatch(setRequestTypeId(repairRequestID.request_type.id));
        dispatch(setRequestType(repairRequestID.request_type.title));
        dispatch(setWagonBuildDate(dayjs(repairRequestID.wagon_build_date)));
        dispatch(setTimeArrival(dayjs(repairRequestID.appearance.time_arrival)));
        dispatch(setCompleteDate(dayjs(repairRequestID.complete_date)));
        dispatch(setTimeDeparture(dayjs(repairRequestID.appearance.time_departure)));

        let client_contact_NoDuplicate = repairRequestID.client_contacts.filter((v, i, a) => a.findIndex(v2 => (v2?.id === v?.id)) === i);
        let wagon_contact_NoDuplicate = repairRequestID.wagon_contacts.filter((v, i, a) => a.findIndex(v2 => (v2?.id === v?.id)) === i);
        setClientContactsIds([...client_contacts_ids, ...client_contact_NoDuplicate.map(contact => Number(contact?.id))]);
        setWagonContactsIds([...wagon_contacts_ids, ...wagon_contact_NoDuplicate.map(contact => Number(contact?.id))]);

      })

    }

    if ((idRequest !== undefined && Number(idRequest) === 0) || idRequest === undefined) {

      setAsynchronous2([1]);
      setAsynchronous2_2([1]);
      dispatch(setReset());
      setClientContactsIds([]);
      setWagonContactsIds([]);


    }



    /// }, [dispatch, idRequest, repairRequestID.client_contacts.length, repairRequestID.wagon_contacts.length]);  //[idRequest, dispatch]);

  }, [dispatch, idRequest, repairRequestID.client_contacts.length, repairRequestID.wagon_contacts.length
    , repairRequestID.num,
    repairRequestID.external_num,
    repairRequestID.wagon_number,
    repairRequestID.staff_wagon_number,
    repairRequestID.route,
    repairRequestID.appearance.station,
    repairRequestID.problems,
    repairRequestID.result.problems,
    repairRequestID.result.description,
    repairRequestID.executor,
    repairRequestID.result.done,
    repairRequestID.wagon_type.title,
    repairRequestID.wagon_type.type,
    repairRequestID.route_number,
    repairRequestID.request_type.id,
    repairRequestID.request_type.title,
    repairRequestID.wagon_build_date,
    repairRequestID.appearance.time_arrival,
    repairRequestID.complete_date,
    repairRequestID.appearance.time_departure
  ],
  );  //[idRequest, dispatch]);

  /////////////////////////////////////////////////////////////////////////////////

  const [openWagonType, setOpenWagonType] = React.useState(false);
  const handleChangeWagonTypeId = (event: SelectChangeEvent<string>) => {
    const value = event.target.value as string;
    dispatch(setWagonType(value))

    var wagon_type = dataWagonTypes?.payload?.filter(function (item) {
      return item.title === value
    })

    if (wagon_type !== undefined) {
      dispatch(setWagonTypeId(wagon_type[0]?.type))
    }

  };

  const handleCloseWagon = () => {
    setOpenWagonType(false);
  };

  const handleOpenWagon = () => {
    setOpenWagonType(true);
  };

  /////////////////////////////////////////////////////////////////////////////////


  /////////////////////////////////////////////////////////////////////////////////

  const [openRequestType, setOpenRequestType] = React.useState(false);
  const handleChangeRequestTypeId = (event: SelectChangeEvent<string>) => {
    const value = event.target.value as string;
    dispatch(setRequestType(value))

    var request_type = dataRequestTypes?.payload?.filter(function (item) {
      return item.title === value
    })

    if (request_type !== undefined) {
      dispatch(setRequestTypeId(request_type[0]?.id))
    }

  };

  const handleCloseRequest = () => {
    setOpenRequestType(false);
  };

  const handleOpenRequest = () => {
    setOpenRequestType(true);
  };

  /////////////////////////////////////////////////////////////////////////////////


  const handleAddAsynchronous2_1 = () => {
    const newA = Date.now()
    setAsynchronous2(v => [...v, newA]);
  }

  const handleAddAsynchronous2_2 = () => {
    setAsynchronous2([...asynchronous2.slice(0, asynchronous2.length - 1), ...asynchronous2.slice(asynchronous2.length, asynchronous2.length),]);

    if (client_contacts_ids.length >= asynchronous2.length) {

      setClientContactsIds([...client_contacts_ids.slice(0, client_contacts_ids.length - ((client_contacts_ids.length - asynchronous2.length + 1))), ...client_contacts_ids.slice(client_contacts_ids.length, client_contacts_ids.length),]);

      dispatch(setClientContacts0([...repairRequest.client_contacts.slice(0, repairRequest.client_contacts.length - ((repairRequest.client_contacts.length - asynchronous2.length + 1))), ...repairRequest.client_contacts.slice(repairRequest.client_contacts.length, repairRequest.client_contacts.length),]));

    }
  }



  //Номер штабного вагона
  const handleWagonNumberChange0 = (value: string, isValid: boolean, number: number) => {
    dispatch(setStaffWagonNumber(value));
  };


  //Номер вагона
  const handleWagonNumberChange1 = (value: string, isValid: boolean, number: number) => {
    // setWagonNumber(value);
    dispatch(setWagonNumber(value));
  };



  const [asynchronous2_2, setAsynchronous2_2] = useState<number[]>([1]);

  const handleAddAsynchronous2_1_2 = () => {
    const newA = Date.now()
    setAsynchronous2_2(v => [...v, newA]);
  }

  const handleAddAsynchronous2_2_2 = () => {
    setAsynchronous2_2([...asynchronous2_2.slice(0, asynchronous2_2.length - 1), ...asynchronous2_2.slice(asynchronous2_2.length, asynchronous2_2.length),]);

    if (wagon_contacts_ids.length >= asynchronous2_2.length) {

      setWagonContactsIds([...wagon_contacts_ids.slice(0, wagon_contacts_ids.length - ((wagon_contacts_ids.length - asynchronous2_2.length + 1))), ...wagon_contacts_ids.slice(wagon_contacts_ids.length, wagon_contacts_ids.length),]);

      dispatch(setWagonContacts0([...repairRequest.wagon_contacts.slice(0, repairRequest.wagon_contacts.length - ((repairRequest.wagon_contacts.length - asynchronous2_2.length + 1))), ...repairRequest.wagon_contacts.slice(repairRequest.wagon_contacts.length, repairRequest.wagon_contacts.length),]));

    }
  }


  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [phone, setPhone] = useState<PhoneArr>([]);
  const [phoneEmpty, setPhoneEmpty] = useState<string>("4959193739");

  const [email, setEmail] = useState<EmailArr>([]);
  const [emailEmpty, setEmailEmpty] = useState<string>("t-64@mail.ru");

  const [position, setPosition] = useState<string>("");
  const [comment, setComment] = useState<string>("");

  //Добавить объект в массив
  const addNewPhoneToArray = (newPhone: string) => {
    setPhone([...phone, newPhone]);
  };

  //Удалить объект из массива 
  const removePhoneToArray = (index: number) => {
    setPhone([
      ...phone.slice(0, index),
      ...phone.slice(index + 1, phone.length),
    ]);
  };

  //Добавить объект в массив
  const addNewEmailToArray = (newEmail: string) => {
    setEmail([...email, newEmail]);



  };

  //Удалить объект из массива 
  const removeEmailToArray = (index: number) => {
    setEmail([
      ...email.slice(0, index),
      ...email.slice(index + 1, email.length),
    ]);
  };


  const [isValidPhone0, setIsValidPhone0] = useState<boolean>(false);
  const [isValidEmail0, setIsValidEmail0] = useState<boolean>(false);



  /////////////////////////////////////////////////////////////////////////////////////

  //Контакты
  const childToParent2_contacts = (childdata2: Contact) => {

    setNeedRefresh(false);
    setContacts2(childdata2);
    setPhone([]);
    setEmail([]);
    setPosition("");
    setComment("");
  };

  const childToParent2_id_contacts = (childdata2: ContactWithID) => {
    setContacts2_id(childdata2);

    setPhone([]);
    childdata2?.phones?.map(function (object, i) {

      setPhone((phone) => [object, ...phone]);
    });


    setEmail([]);
    childdata2?.emails?.map(function (object, i) {

      setEmail((email) => [object, ...email]);
    });

    //setPosition("");
    setPosition(childdata2?.position && childdata2?.position !== null ? childdata2?.position : "");
    setComment(childdata2?.comment && childdata2?.comment !== null ? childdata2?.comment : "");


  };


  //Обновление телефона
  const handlePhoneNumberChange0 = (value: string, isValid: boolean, number: number) => {
    let phone2 = [...phone];
    phone2[number] = value;
    setPhone(phone2);
    setIsValidPhone0(isValid);
  };

  //Обновление email
  const handleEmailChange0 = (value: string, isValid: boolean, number: number) => {
    let email2 = [...email];
    email2[number] = value;
    setEmail(email2);
    setIsValidEmail0(isValid);
  };


  /////////////////////////////////////////////////////////////////////////////////////


  const sendValueInsertContact = (contact: ContactWithOutID) => {

    dispatch(contactsDataPost(contact)).then(() => {

      dispatch(contactsData3()).then(() => {
        if (clients1_id !== undefined) dispatch(contactsData(clients1_id));
      }

      )
    })
  }


  const sendValueUpdateContact = (contact: ContactWithID) => {

    dispatch(contactsDataUpdate(contact)).then(() => {

      if (clients1_id !== undefined) dispatch(contactsData(clients1_id));
    })

  }





  const saveRequest = (saveas: boolean) => {


    let client_contact_NoDuplicate = repairRequest.client_contacts.filter((v, i, a) => a.findIndex(v2 => (v2?.id === v?.id)) === i);
    let wagon_contact_NoDuplicate = repairRequest.wagon_contacts.filter((v, i, a) => a.findIndex(v2 => (v2?.id === v?.id)) === i);

    dispatch(setClientContacts0(client_contact_NoDuplicate));

    dispatch(setWagonContacts0(wagon_contact_NoDuplicate));

    if (client_contacts_ids.length < asynchronous2.length) {

      alert('Неверно заполнены контакты клиента!' + "  " + client_contacts_ids.length + "  " + asynchronous2.length); return;

    }

    if (wagon_contacts_ids.length < asynchronous2_2.length) {

      alert('Неверно заполнены контакты на вагоне!' + "  " + wagon_contacts_ids.length + "  " + asynchronous2_2.length); return;

    }

    if (clients1_id?.id !== undefined) {

      let repair: InsertRepair = {
        request_date: new Date().toISOString(),
        request_type_id: Number(repairRequest.request_type.id),
        num: repairRequest.num,
        client_id: clients1_id?.id,
        client_contact_ids: client_contact_NoDuplicate.map(contact => Number(contact?.id!)),
        external_num: repairRequest.external_num,
        wagon_type_id: repairRequest.wagon_type.type!,
        wagon_number: repairRequest.wagon_number,
        staff_wagon_number: repairRequest.staff_wagon_number,
        wagon_build_date: String((dayjs(repairRequest.wagon_build_date).format('YYYY-MM-DD'))),
        route_number: repairRequest.route_number,
        route: repairRequest.route,
        appearance: {
          time_arrival: String((dayjs(repairRequest.appearance.time_arrival).format('DD.MM.YYYY HH:mm'))),
          time_departure: String((dayjs(repairRequest.appearance.time_departure).format('DD.MM.YYYY HH:mm'))),
          station: repairRequest.appearance.station
        },
        problems: repairRequest.problems,
        complete_date: String((dayjs(repairRequest.complete_date).format('YYYY-MM-DD'))),
        result: {
          done: repairRequest.result.done,
          problems: repairRequest.result.problems,
          description: repairRequest.result.description
        },
        executor: repairRequest.executor,
        wagon_contacts_ids: wagon_contact_NoDuplicate.map(contact => Number(contact?.id!)),
        id: idRequest !== undefined && Number(idRequest) > 0 ? Number(idRequest) : 0
      };

      repair.id > 0 ? (saveas === false ? sendValueUpdate(repair) : sendValueInsert(repair)) : sendValueInsert(repair);

      let textSnack: TypeSnack = {
        children: repair.id > 0 ? (saveas === false ? 'Изменили запрос' : 'Создали копию запроса') : 'Создали запрос',
        title: 'success',
      };

      setSnackbar(textSnack);

    }


  };
  



  const [files, setFiles] = useState<ExtendedFileProps[]>([]);

  const handleFilesChange = (files : ExtendedFileProps[]) => {
    // Update chosen files
    setFiles([ ...files ])
  };

  const handleFileUploadError = (error: any) => {
    // Do something...
  }

  const handleFormSubmit = () => {
   
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      console.log(files[i])
      formData.append("file", files[i]);
    }

    dispatch(dataUpload(formData));
};


  return (


    

    <div className="main-page" style={{ height: "100%", width: "1200px", left: '0px', top: '0px', columnCount: 3, }}>

{( loading) && (
         <Box>
          <CircularProgress
            size={200}
            sx={{
              color: green[500],
              position: 'absolute',
              top: '40%',
              left: '50%',
              width: '100px',
              height: '100px',
            }}
          />
          </Box>
        )}

      {/*client_id*/}
      <Asynchronous
        key={"child1"}

        clear={false}
        sx={{ display: "block", width: 300, left: "0px" }}
        childToParent={childToParent1_clients}
        childToParent_id={childToParent1_id_clients}
        dataParentToChild={handleParentToChild}

        dataRows={
          dataClients?.payload?.list
            ? dataClients?.payload.list.map((option) => ({
              id: option.id,
              label: option["title"] + "",
            }))
            : []
        }

        value2={Number(idRequest) !== 0 ? (repairRequestID.client.title) : ""}

        field={"label"}
        name={"Клиент"}
        freesl={false}
      />




      {asynchronous2.map((asynchronous2, i) =>

        <Asynchronous2
          key={"child2" + i}
          clear={(!clients1_id ? true : false) || needRefresh}
          sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}
          childToParent={childToParent3_contact3}
          childToParent_id={childToParent3_id_contact3}
          childToParent_id_clear={childToParent3_id_contact3_clear}
          dataParentToChild={handleParentToChild}

          value2={Number(idRequest) !== 0 && client_contacts_ids.length - 1 >= i ? (client_contacts_ids[i] === repairRequestID.client_contacts[i]?.id ? repairRequestID.client_contacts[i]?.name : "new") : ""} //wagon_contacts_ids
          value3={Number(idRequest) !== 0 && client_contacts_ids.length - 1 >= i && (client_contacts_ids[i] === repairRequestID.client_contacts[i]?.id) ? (repairRequestID.client_contacts[i]) : ""}

          dataRows={
            dataContacts?.payload && clients1_id && typeof dataContacts?.payload?.map === "function"
              ? dataContacts?.payload?.map((option) => ({
                id: option?.id,
                client: option?.client,
                comment: option?.comment,
                emails: option?.emails,
                name: option?.name,
                phones: option?.phones,
                position: option?.position,
                label: option?.name + ""
              }))
              : []
          }
          name={"Контакты"}
          freesl={true}
        />
      )}


      <ButtonGroup variant="contained" aria-label="outlined primary button group">

        <Button
          disabled={clients1_id?.id! ? false : true}

          onClick={() => {
            handleAddAsynchronous2_1()
          }}>+</Button>
        <Button
          disabled={clients1_id?.id! ? false : true}
          onClick={() => {
            if (asynchronous2.length > 1) handleAddAsynchronous2_2()
          }}>-</Button>


        <Button
          disabled={clients1_id?.id! ? false : true}
          onClick={() => {

            setPhone([]);
            setEmail([]);
            setContacts2("");
            setContacts2_id(null);
            setPosition("");
            setComment("");

            handleClickOpenDialog();

          }}>Новый контакт</Button>


      </ButtonGroup>


      {openDialog === true ? <Dialog

        fullWidth={true}
        maxWidth={false}
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <DialogTitle>Новый контакт</DialogTitle>
        <DialogContent style={{ height: '600px' }}>
          <DialogContentText>
            В этой форме нужно создать новый контакт.
          </DialogContentText>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >

            <Asynchronous
              key={"child2"}
              clear={(!clients1_id ? true : false) || needRefresh}
              sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}
              childToParent={childToParent2_contacts}
              childToParent_id={childToParent2_id_contacts}
              dataParentToChild={handleParentToChild}
              dataRows={
                dataContacts?.payload && clients1_id && typeof dataContacts?.payload?.map === "function"
                  ? dataContacts?.payload?.map((option) => ({
                    id: option?.id,
                    client: option?.client,
                    comment: option?.comment,
                    emails: option?.emails,
                    name: option?.name,
                    phones: option?.phones,
                    position: option?.position,
                    label: option?.name + ""
                  }))
                  : []
              }
              value2={""}
              field={"name"}
              name={"Контакты"}
              freesl={true}
            />


            <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}>
              <InputLabel shrink htmlFor="text-mask-input">
                {"Должность"}
              </InputLabel>
              <OutlinedInput
                sx={{
                  height: "55px", notchedOutline: {
                    "& legend": {
                      visibility: "visible",
                    }
                  }
                }}
                placeholder={"Должность"}

                value={position}

                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setPosition(e.target.value);
                }}

                name="position"
                label={"Должность"}
                fullWidth={true}
                size={"small"}
                notched
                aria-describedby="base-name-helper-text"
                inputProps={{
                  "aria-label": "weight",
                }}
              />
            </FormControl>


            <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}>
              <InputLabel shrink htmlFor="text-mask-input">
                {"Комментарий"}
              </InputLabel>
              <OutlinedInput
                sx={{
                  height: "55px", notchedOutline: {
                    "& legend": {
                      visibility: "visible",
                    }
                  }
                }}
                placeholder={"Комментарий"}

                value={comment}

                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setComment(e.target.value);
                }}

                name="comment"
                label={"Комментарий"}
                fullWidth={true}
                size={"small"}

                notched
                aria-describedby="base-name-helper-text"
                inputProps={{
                  "aria-label": "weight",
                }}
              />
            </FormControl>


            {phone && phone.length ? (
              phone?.map((object, i) => (
                <React.Fragment key={object + String(i)}>


                  <Box sx={{ marginTop: "20px" }}>
                    <InputPhoneField
                      placeholder="Номер телефона"
                      helperText="Номер телефона"
                      label="Phone"
                      fieldName="Phone"
                      objectPhone={phone[i]}
                      value={phone[i]}
                      handleChange={handlePhoneNumberChange0}
                      array={i}
                    />

                  </Box>


                </React.Fragment>
              ))
            ) : (
              <></>
            )}


            {email && email.length ? (
              email?.map((object, i) => (
                <React.Fragment key={object + String(i)}>

                  <Box sx={{ marginTop: "20px" }}>
                    <InputPhoneField
                      helperText="Электронная почта"
                      placeholder="Электронная почта"
                      label="Email"
                      fieldName="Email"
                      objectPhone={email[i]}
                      value={email[i]}
                      handleChange={handleEmailChange0}
                      array={i}
                    />
                  </Box>

                </React.Fragment>
              ))
            ) : (
              <></>
            )}

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { if (contacts2) addNewPhoneToArray(phoneEmpty); }}>Добавить телефон</Button>
          <Button onClick={() => { if (contacts2) removePhoneToArray(phone.length - 1); }}>Убрать телефон</Button>
          <Button onClick={() => { if (contacts2) addNewEmailToArray(emailEmpty); }}>Добавить Email</Button>
          <Button onClick={() => { if (contacts2) removeEmailToArray(email.length - 1); }}>Убрать Email</Button>

          <Button autoFocus onClick={() => {

            if (!contacts2) { alert('Не задан контакт!'); return; }

            if (!isValidPhone0 || phone?.length === 0) { alert('Неверный телефон!'); return; }
            if (!isValidEmail0 || email?.length === 0) { alert('Неверный емейл!'); return; }



            if (clients1_id?.id !== undefined && contacts2_id?.id === undefined) {

              let contact: ContactWithOutID = {
                client: clients1_id,
                name: contacts2,
                phones: phone,
                emails: email,
                position: position,
                comment: comment,
              };

              sendValueInsertContact(contact);

              let textSnack: TypeSnack = {
                children: 'Создали контакт',
                title: 'success',
              };

              setSnackbar(textSnack);

              handleCloseDialog();

            }

            if (clients1_id?.id !== undefined && contacts2_id?.id !== undefined) {

              let contact: ContactWithID = {
                id: contacts2_id?.id,
                client: clients1_id,
                name: contacts2,
                phones: phone,
                emails: email,
                position: position,
                comment: comment,
              };

              sendValueUpdateContact(contact);

              let textSnack: TypeSnack = {
                children: 'Изменили контакт',
                title: 'success',
              };

              setSnackbar(textSnack);

              handleCloseDialog();

            }


          }}>Сохранить</Button>
          <Button onClick={handleCloseDialog}>Закрыть</Button>
        </DialogActions>
      </Dialog>


        : ""}


      {/*num*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Номер запроса"}
        </InputLabel>
        <OutlinedInput

          disabled

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Номер запроса"}
          value={repairRequest.num}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            dispatch(setNum(Number(e.target.value)));

          }}

          name="num"
          type="number"
          label={"Номер запроса"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>



      {/*external_num*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Внешний номер"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Номер"}
          value={repairRequest.external_num}
          //value={Number(idRequest) !== 0 ? (repairRequestID.external_num) : repairRequest.external_num}


          onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            dispatch(setExternalNum(String(e.target.value)));

          }}
          name="external_num"
          type="text"
          label={"Внешний номер"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>


      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputPhoneField

          helperText="Номер вагона"
          placeholder="Номер вагона"
          label="wagon_number"
          fieldName="WagonNumber"
          objectPhone={repairRequest.wagon_number}
          value={repairRequest.wagon_number}
          handleChange={handleWagonNumberChange1}
          array={0}
        />
      </FormControl>


      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputPhoneField

          helperText="Номер штабного вагона"
          placeholder="Номер штабного вагона"
          label="staff_wagon_number"
          fieldName="WagonNumber"
          objectPhone={repairRequest.staff_wagon_number}
          value={repairRequest.staff_wagon_number}
          handleChange={handleWagonNumberChange0}
          array={0}
        />
      </FormControl>


      {/*wagon_build_date*/}

      {<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru"

        localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>

        <DatePicker sx={{ display: "block", height: "55px", marginTop: "20px", width: 500 }}
          label="Дата постройки вагона"
          value={dayjs(repairRequest.wagon_build_date)}
          onChange={(newValue) => dispatch(setWagonBuildDate(dayjs(newValue)))}

        />
      </LocalizationProvider>
      }


      {/*wagon_type_id*/}
      <FormControl sx={{ display: "block", height: "55px", marginTop: "20px", width: 100 }}>
        <InputLabel shrink id="demo-controlled-open-select-label">Тип вагона</InputLabel>
        <Select

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}

          notched
          placeholder={"Тип вагона"}
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={openWagonType}
          onClose={handleCloseWagon}
          onOpen={handleOpenWagon}
          value={repairRequest.wagon_type.title}
          label="Тип вагона"
          onChange={handleChangeWagonTypeId}
        >

          {dataWagonTypes?.payload?.map((type) => (
            <MenuItem key={type.type} value={type.title}>
              {type.title}
            </MenuItem>
          ))}

        </Select>
      </FormControl>


      {/*request_type_id*/}
      <FormControl sx={{ display: "block", height: "55px", marginTop: "20px", width: 100 }}>
        <InputLabel shrink id="demo-controlled-open-select-label">Тип запроса</InputLabel>
        <Select

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}

          notched
          placeholder={"Тип запроса"}
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={openRequestType}
          onClose={handleCloseRequest}
          onOpen={handleOpenRequest}
          value={repairRequest.request_type.title}
          label="Тип запроса"
          onChange={handleChangeRequestTypeId}
        >

          {dataRequestTypes?.payload?.map((type) => (
            <MenuItem key={type.id} value={type.title}>
              {type.title}
            </MenuItem>
          ))}

        </Select>
      </FormControl>


      {/*route_number*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Номер маршрута"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Номер маршрута"}


          defaultValue={repairRequest.route_number}

          onChange={(e) => dispatch(setRouteNumber(e.target.value))}

          name="route_number"
          type="string"
          label={"Номер маршрута"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>


      {/*route*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Маршрут"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Маршрут"}
          value={repairRequest.route}
          onChange={(e) => dispatch(setRoute(e.target.value))}
          name="route"
          type="text"
          label={"Маршрут"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>


      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru"

        localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}

      >

        {/*time_departure*/}
        <DateTimePicker
          sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}
          label="Время отправления"
          value={dayjs(repairRequest.appearance.time_departure)}
          onChange={(newValue) => dispatch(setTimeDeparture(dayjs(newValue)))}
        />

        {/*time_arrival*/}
        <DateTimePicker
          sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}
          label="Время прибытия"
          value={dayjs(repairRequest.appearance.time_arrival)}
          onChange={(newValue) => dispatch(setTimeArrival(dayjs(newValue)))}
        />

      </LocalizationProvider>



      {/*station*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Станция назначения"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Станция назначения"}


          value={repairRequest.appearance.station}

          onChange={(e) => dispatch(setStation(e.target.value))}

          name="station"
          type="text"
          label={"Станция назначения"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>


      {/*problems*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Проблемы"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Проблемы"}

          value={repairRequest.problems}

          onChange={(e) => dispatch(setProblems(e.target.value))}

          name="problems"
          type="text"
          label={"Проблемы"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>



      {<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru"

        localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>


        {/*complete_date*/}

        <DatePicker
          sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}
          label="Время выполнения"
          value={dayjs(repairRequest.complete_date)}
          onChange={(newValue) => dispatch(setCompleteDate(dayjs(newValue)))}

        />
      </LocalizationProvider>
      }




      {/*done*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Что сделано"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Что сделано"}

          value={repairRequest.result.done}

          onChange={(e) => dispatch(setDone(e.target.value))}

          name="done"
          type="text"
          label={"Что сделано"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>



      {/*result_problems*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Какая проблема не решена"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Какая проблема не решена"}


          value={repairRequest.result.problems}

          onChange={(e) => dispatch(setResultProblems(e.target.value))}

          name="result_problems"
          type="text"
          label={"Какая проблема не решена"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>




      {/*description*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Описание"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Описание"}


          value={repairRequest.result.description}

          onChange={(e) => dispatch(setDescription(e.target.value))}

          name="description"
          type="text"
          label={"Описание"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>






      {/*executor*/}
      <FormControl variant="outlined" sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}>
        <InputLabel shrink >
          {"Исполнитель"}
        </InputLabel>
        <OutlinedInput

          sx={{
            height: "55px", notchedOutline: {
              "& legend": {
                visibility: "visible",
              }
            }
          }}
          placeholder={"Исполнитель"}


          value={repairRequest.executor}

          onChange={(e) => dispatch(setExecutor(e.target.value))}

          name="executor"
          type="text"
          label={"Исполнитель"}
          fullWidth={true}
          size={"small"}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>

      {/*wagon_contacts_ids */}
      {asynchronous2_2.map((asynchronous2_2, i) =>



        // ((Number(idRequest) !== 0 && repairRequestID.wagon_contacts[i]?.name !== undefined) || Number(idRequest) === 0) ? 
        <Asynchronous2
          key={"child3" + i}
          clear={needRefresh}
          sx={{ display: "block", height: "55px", marginTop: "20px", width: 300 }}
          childToParent={childToParent3_contact3_2}
          childToParent_id={childToParent3_id_contact3_2}
          childToParent_id_clear={childToParent3_id_contact3_2_clear}
          dataParentToChild={handleParentToChild}

          value2={Number(idRequest) !== 0 && wagon_contacts_ids.length - 1 >= i ? (wagon_contacts_ids[i] === repairRequestID.wagon_contacts[i]?.id ? repairRequestID.wagon_contacts[i]?.name : "new") : ""} //wagon_contacts_ids
          value3={Number(idRequest) !== 0 && wagon_contacts_ids.length - 1 >= i && (wagon_contacts_ids[i] === repairRequestID.wagon_contacts[i]?.id) ? (repairRequestID.wagon_contacts[i]) : ""}

          // value2={Number(idRequest) !== 0 && wagon_contacts_ids.length-1 >= i ? repairRequestID.wagon_contacts[i]?.name : ""} //wagon_contacts_ids
          // value3={Number(idRequest) !== 0 && wagon_contacts_ids.length-1 >= i ? (repairRequestID.wagon_contacts[i]) : ""}

          dataRows={
            dataContacts3?.payload && typeof dataContacts3?.payload?.map === "function"
              ? dataContacts3?.payload?.map((option) => ({
                id: option?.id,
                client: option?.client,
                comment: option?.comment,
                emails: option?.emails,
                name: option?.name,
                phones: option?.phones,
                position: option?.position,
                label: option?.name + ""
              }))
              : []
          }
          name={"Контакты на вагоне"}
          freesl={true}
        />
        //  : ""

      )}





      <ButtonGroup variant="contained" aria-label="outlined primary button group">
        <Button onClick={() => {
          handleAddAsynchronous2_1_2()
        }}>+</Button>
        <Button
          onClick={() => {
            if (asynchronous2_2.length > 1) handleAddAsynchronous2_2_2()
          }}>-</Button>

      </ButtonGroup>



      <div>

      <FileUpload 
        //value={files} 
        multiFile={true}
        disabled={false}
        onFilesChange={handleFilesChange}
        onError={handleFileUploadError}
        title = {"Загрузка файлов"}
        header="Перетащите файлы"
        leftLabel="или"
        rightLabel="для выбора файлов"
        buttonLabel="Нажмите здесь"
        errorSizeMessage={'Ошибка объема файлов'}
        buttonRemoveLabel="Убрать все"
        imageSrc={'/logo_detewe_service.png'}
           
        />

        <Button
          sx={{

            color: "white",

            top: 0,
            left: 0,
            height: 40,
            position: "relative",
            width: 150,

            "&:hover": {

            },
          }}
          variant="contained"
          onClick={handleFormSubmit}
        >
          Отправить
        </Button> 
        
        </div>





{/*
      <Button autoFocus
        sx={{

          color: "white",
          backgroundColor: "#16b8f3",

          display: "block", height: "35px", marginTop: "40px", width: 300,

          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          navigate('/requests');
        }}
      >
        Отмена
      </Button>*/}


      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={snackbar.children !== 'Создали контакт' && snackbar.children !== 'Изменили контакт' ? handleCloseSnackbar : handleCloseSnackbar0}
          autoHideDuration={2000}
        >
          <Alert {...snackbar} onClose={snackbar.children !== 'Создали контакт' && snackbar.children !== 'Изменили контакт' ? handleCloseSnackbar : handleCloseSnackbar0}
          />
        </Snackbar>
      )

      }


      <Button
        sx={{

          color: "white",
          backgroundColor: "#16b8f3",

          position: "absolute", height: "35px", bottom: Number(idRequest) > 0 ? "95px" : "50px", width: 250, right: 145,

          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          saveRequest(false);

        }}
      >
        {Number(idRequest) > 0 ? "Изменить" : "Сохранить"}
      </Button>



      {Number(idRequest) > 0 ?

        <Button
          sx={{

            color: "white",
            backgroundColor: "#16b8f3",

            position: "absolute", height: "35px", bottom: "50px", width: 250, right: 145,

            transform: "translateY(-50%)",

            "&:hover": {
              backgroundColor: "#12a8df",
            },
          }}
          variant="contained"
          onClick={() => {

            saveRequest(true);

          }}
        >
          Сохранить как новый
        </Button> : ""

      }

      <Button autoFocus
        sx={{

          color: "white",
          backgroundColor: "#16b8f3",

          position: "absolute", height: "35px", bottom: "5px", width: 250, right: 145,

          transform: "translateY(-50%)",

          "&:hover": {
            backgroundColor: "#12a8df",
          },
        }}
        variant="contained"
        onClick={() => {

          navigate('/requests');
        }}
      >
        Отмена
      </Button>

    </div>

  )
}


